import React from "react";
import "./App.css";
import Listings from "./Listings";
import backgroundHeader from "./images/bg-header-desktop.svg";

export default function App() {
	return (
		<main className="App">
			<img className="bg-img" src={backgroundHeader} alt="design pattern" />
			<Listings />
		</main>
	);
}
